import { queryOptions } from '@tanstack/react-query';

import { shortCacheOptions } from '@platform/core/state';

import { getCapabilityApiClient } from '../capability-api-client';

export const getCapabilitiesQueryKey = (orgId: string) => {
  return [orgId, 'capability', 'get-user-jwt-capabilities-by-organization'];
};

export const capabilitiesQuery = (orgID: string) =>
  queryOptions({
    queryFn: async () => {
      const client = await getCapabilityApiClient();
      return client.getUserJWTCapabilitiesByOrganization({
        orgID,
      });
    },
    queryKey: getCapabilitiesQueryKey(orgID),
    ...shortCacheOptions,
  });
